import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { ITimeUnits } from '../../../../../../../../../types/model';
import { IGetState, TCardId } from '../../../../../../../../../types/types';
import { notificationsBeforeDueDatesForCardUpdate } from '../../../state/effects/notificationsBeforeDueDatesForCardUpdate';

export const onChangeTimeUnit: ActionCreator<ThunkAction> = (
    cardId: TCardId,
    notificationId: number,
    timeUnit: ITimeUnits,
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const cardEditedState = getState().notificationBeforeDueDateEdits[cardId];
        if (cardEditedState) {
            const targetNotifications = cardEditedState.notifications;
            const newEditedState = targetNotifications.map((item) => {
                if (item.id === notificationId) {
                    return {
                        ...item,
                        unit:timeUnit
                    }
                }
                return item;
            });
            dispatch(notificationsBeforeDueDatesForCardUpdate(cardId, newEditedState));
        }
    };
    return action;
};
